import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Matrikkelenhet from './Matrikkelenhet.jsx'
import MatrikkelenhetIcon from '../../../images/Matrikkelenhet.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class MatrikkelenhetList extends Component {
    state = {
        matrikkelenheter: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getMatrikkelenheter = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}/matrikkelenhet`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                matrikkelenheter: [...this.state.matrikkelenheter, ...data.matrikkelenheter],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }

    toggleMatrikkelenheter = () => {
        if (this.props.antall == 0) return

        if (this.state.matrikkelenheter.length == 0) {
            this.getMatrikkelenheter()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallMatrikkelenheter = this.state.continuationToken ? `${this.state.matrikkelenheter.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleMatrikkelenheter}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={MatrikkelenhetIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('matrikkelenheter')} ({antallMatrikkelenheter})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.matrikkelenheter.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.matrikkelenheter.map((m, index) => { return (<Matrikkelenhet key={m.matrikkelenhetId} matrikkelenhet={m} antall={this.props.antall} isLast={index==this.state.matrikkelenheter.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getMatrikkelenheter}>
                                <span>{t('hent.matrikkelenheter')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(MatrikkelenhetList)